import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ss-tamanho-completo ss-alinhar-centro" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_6 = ["titulo"]
const _hoisted_7 = { style: {"font-weight":"500"} }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "ant-row ss-grade-personalizada-titulo" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-9" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Tabela")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Tipo")
], -1)
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_18 = { class: "ss-titulo-campo" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Markup")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Desconto Máximo")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "ant-row ss-grade-personalizada-linha"
}
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_23 = { class: "ss-margin-campos" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_25 = { class: "ss-margin-campos" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_27 = { class: "ss-margin-campos" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_29 = { class: "ss-margin-campos" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_31 = { class: "ss-margin-campos" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_tipo_custo = _resolveComponent("selecionar-tipo-custo")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.props.carregando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_card, { titulo: " " }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_spin, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Carregando preços")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              (_ctx.props.tabelasPrecos.length <= 0)
                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                    key: 0,
                    mensagem: "Nenhum tipo de preço ou tabela não foi cadastrada ainda"
                  }))
                : (_ctx.computedPrecos.length > 0)
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 1,
                      titulo: "PREÇOS DE VENDA"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.props.tabelasPrecos.length === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.tabelasPrecos[0].estruturas, (estrutura, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass((_ctx.props.tabelasPrecos[0].estruturas.length > 1) ? ((index % 2) ? 'ant-col ant-col-xs-24 ant-col-xl-12 ss-separador' : 'ant-col ant-col-xs-24 ant-col-xl-12') : 'ant-col ant-col-xs-24 ant-col-xl-24')
                                }, [
                                  _createElementVNode("div", {
                                    titulo: estrutura.descricaoTipoPreco,
                                    style: {"margin-left":"5px"}
                                  }, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(estrutura.descricaoTipoPreco), 1),
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Baseado no",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_selecionar_tipo_custo, {
                                              codigoSelecionado: _ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].codigoTipoCusto,
                                              "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].codigoTipoCusto) = $event),
                                              empresas: [_ctx.props.empresa],
                                              limparSelecao: false
                                            }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("div", _hoisted_10, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Markup",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_numerico, {
                                              valor: _ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].markup,
                                              "onUpdate:valor": ($event: any) => ((_ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].markup) = $event),
                                              percentual: true,
                                              onValorDigitado: ($event: any) => (_ctx.atualizarPrecoMarkup(_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco), true))
                                            }, null, 8, ["valor", "onUpdate:valor", "onValorDigitado"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("div", _hoisted_11, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Preço de venda",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_numerico, {
                                              valor: _ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].valor,
                                              "onUpdate:valor": ($event: any) => ((_ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].valor) = $event),
                                              monetario: true,
                                              quantidadeCasasDecimais: estrutura.casasDecimaisTipoPreco,
                                              onValorDigitado: ($event: any) => (_ctx.atualizarPrecoMarkup(_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco), false))
                                            }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais", "onValorDigitado"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Desconto Máximo",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_numerico, {
                                              valor: _ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].descontoMaximo,
                                              "onUpdate:valor": ($event: any) => ((_ctx.computedPrecos[_ctx.obterIndex(estrutura.codigoTabelaPreco, estrutura.codigoTipoPreco)].descontoMaximo) = $event),
                                              percentual: true
                                            }, null, 8, ["valor", "onUpdate:valor"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ])
                                  ], 8, _hoisted_6)
                                ], 2))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.tiposPrecos, (tipoPreco, indexTipoPreco) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexTipoPreco }, [
                                  _createElementVNode("span", null, _toDisplayString(tipoPreco.descricao), 1),
                                  _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _hoisted_16,
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(tipoPreco.descricao), 1)
                                    ]),
                                    _hoisted_19,
                                    _hoisted_20
                                  ]),
                                  _createVNode(_component_a_form, {
                                    name: 'ss-form-produto-precos' + tipoPreco,
                                    class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.tabelasPrecos, (tabelaPreco, indexTabela) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: (indexTipoPreco + indexTabela)
                                        }, [
                                          (_ctx.verificarTipoPrecoEstrutura(tipoPreco.codigo, tabelaPreco))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                  _createElementVNode("div", _hoisted_23, _toDisplayString(tabelaPreco.descricao), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_24, [
                                                  _createElementVNode("div", _hoisted_25, _toDisplayString(tabelaPreco.conceitoPrecificacaoDescricao), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_26, [
                                                  _createElementVNode("div", _hoisted_27, [
                                                    _createVNode(_component_campo_numerico, {
                                                      valor: _ctx.computedPrecos[_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo)].valor,
                                                      "onUpdate:valor": ($event: any) => ((_ctx.computedPrecos[_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo)].valor) = $event),
                                                      monetario: true,
                                                      quantidadeCasasDecimais: tipoPreco.casasDecimais,
                                                      onValorDigitado: ($event: any) => (_ctx.atualizarPrecoMarkup(_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo), false))
                                                    }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais", "onValorDigitado"])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_28, [
                                                  _createElementVNode("div", _hoisted_29, [
                                                    _createVNode(_component_campo_numerico, {
                                                      valor: _ctx.computedPrecos[_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo)].markup,
                                                      "onUpdate:valor": ($event: any) => ((_ctx.computedPrecos[_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo)].markup) = $event),
                                                      percentual: true,
                                                      onValorDigitado: ($event: any) => (_ctx.atualizarPrecoMarkup(_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo), true))
                                                    }, null, 8, ["valor", "onUpdate:valor", "onValorDigitado"])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_30, [
                                                  _createElementVNode("div", _hoisted_31, [
                                                    _createVNode(_component_campo_numerico, {
                                                      valor: _ctx.computedPrecos[_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo)].descontoMaximo,
                                                      "onUpdate:valor": ($event: any) => ((_ctx.computedPrecos[_ctx.obterIndex(tabelaPreco.codigo, tipoPreco.codigo)].descontoMaximo) = $event),
                                                      percentual: true
                                                    }, null, 8, ["valor", "onUpdate:valor"])
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["name"])
                                ]))
                              }), 128))
                            ]))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
  ]))
}